const TOPICS_INDEX = [
  { id: 'i1', title: '七月娱乐圈大事记', desc: '本月娱乐圈热门事件全收录，从绯闻曝光到官宣回应，完整梳理吃瓜时间线。', count: '23 篇', tag: '娱乐' },
  { id: 'i2', title: '网红圈翻车合集', desc: '近期网红翻车事件汇总，从直播带货到人设崩塌，盘点那些让人猝不及防的翻车现场。', count: '18 篇', tag: '网红' },
  { id: 'i3', title: '社会热点深度追踪', desc: '持续追踪网络热议的社会事件，多角度呈现事件全貌，不错过每一个关键节点。', count: '31 篇', tag: '社会' },
  { id: 'i4', title: '热搜事件完整复盘', desc: '微博热搜、抖音热榜事件完整时间线整理，让你一次性了解事件来龙去脉。', count: '27 篇', tag: '热搜' },
  { id: 'i5', title: '情感爆料特辑', desc: '整理近期热门情感爆料与吃瓜投稿，聚焦感情、家庭与职场纠葛中的热门话题。', count: '15 篇', tag: '爆料' },
  { id: 'i6', title: '网络大事件年度盘点', desc: '回顾今年以来最具影响力的网络大事件，从爆火到落幕的完整追踪记录。', count: '42 篇', tag: '年度' },
  { id: 'i7', title: '直播圈热门事件', desc: '直播平台最新热点追踪，从带货争议到才艺翻车，记录直播圈的每一个名场面。', count: '19 篇', tag: '直播' },
  { id: 'i8', title: '海外热搜速递', desc: '同步追踪海外社交媒体热门话题与事件，日韩欧美娱乐圈最新吃瓜信息一站掌握。', count: '16 篇', tag: '海外' },
];

export default function TopicIndex() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门专题合集
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          精选热门事件专题，一站式吃瓜体验
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {TOPICS_INDEX.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <span className="inline-block bg-accent-100 text-accent-700 text-xs font-medium px-2.5 py-1 rounded-full mb-3 whitespace-nowrap">
                {item.tag}
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {item.desc}
              </p>
              <span className="text-xs text-foreground-500">
                <i className="ri-file-text-line mr-1"></i>
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}